import { Button, SimpleButtonProps } from 'src/v2/commonComponents/Button';
import styles from './DownloadFileButton.module.scss';

interface DownloadFileButtonProps extends SimpleButtonProps {
  title: string;
  isNew: boolean;
  displayedFormat: string;
}

export const DownloadFileButton = ({
  title,
  isNew,
  displayedFormat,
  onClick,
  ...props
}: DownloadFileButtonProps) => {
  return (
    <Button onClick={onClick} fullWidth color="transparent" {...props}>
      <span className={styles.title}>{title}</span>
      {isNew && <span className={styles.newLabel}>New</span>}
      <span>(.{displayedFormat})</span>
    </Button>
  );
};
